import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import { createApp } from "vue";
import axios from 'axios';

import App from './App.vue';
import router from './router';
import store from './store';
import { createI18n } from 'vue-i18n';

import ja from './views/localeLanguage/ja';
import tw from './views/localeLanguage/tw';


const i18n = createI18n({
  legacy: false,
  locale: 'ja',
  messages: {
    ja,
    tw,
  },
})

const app = createApp(App);

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:5000/';   // the FastAPI backend

axios.interceptors.response.use(undefined, function (error) {
  //console.log("[[[test]]]", error);
  if (error) {
    const originalRequest = error.config;
    // 檢查 error.response 是否存在，避免網絡錯誤時訪問 undefined
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      //console.log("Intercepted an error response:", error);
      originalRequest._retry = true;
      store.dispatch('logOut');
      // return router.push('/login');
      router.push('/login');
    }
    //console.log("[[[return test]]]");
    return Promise.reject(error);
  }
});

app.use(router);
app.use(store);
app.use(i18n);

// app.component('paginate', Paginate);

// 過濾瀏覽器擴展相關的錯誤（不影響應用功能）
window.addEventListener('error', (event) => {
  // 過濾瀏覽器擴展相關的錯誤
  if (
    event.message && (
      event.message.includes('runtime.lastError') ||
      event.message.includes('message port closed') ||
      event.message.includes('Extension context invalidated') ||
      event.message.includes('chrome-extension://') ||
      event.message.includes('moz-extension://')
    )
  ) {
    event.preventDefault(); // 阻止錯誤顯示在控制台
    return false;
  }
});

// 過濾未處理的 Promise 拒絕（瀏覽器擴展相關）
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || event.reason?.toString() || '';
  if (
    errorMessage.includes('runtime.lastError') ||
    errorMessage.includes('message port closed') ||
    errorMessage.includes('Extension context invalidated') ||
    errorMessage.includes('chrome-extension://') ||
    errorMessage.includes('moz-extension://')
  ) {
    event.preventDefault(); // 阻止錯誤顯示在控制台
    return false;
  }
});

app.mount("#app");
